const FAN_PRODUCTS = [
  // --- Mevcut ürünler ---
  {
    id: 'BAF-25',
    brand: 'BOREAS',
    model: 'BAF-25',
    type: 'Hücreli Aspiratör', 
    flow: 2500,
    image: '/images/aspirator/Boreas-BAF.jpg',
    catalog: '/docs/BOREAS_Klima-Santrali-Katalog.pdf'
  },
  {
    id: 'BAF-50',
    brand: 'BOREAS',
    model: 'BAF-50',
    type: 'Hücreli Aspiratör', 
    flow: 5000,
    image: '/images/aspirator/Boreas-BAF.jpg',
    catalog: '/docs/BOREAS_Klima-Santrali-Katalog.pdf'
  },
  {
    id: 'BAF-75',
    brand: 'BOREAS',
    model: 'BAF-75',
    type: 'Hücreli Aspiratör', 
    flow: 7500,
    image: '/images/aspirator/Boreas-BAF.jpg',
    catalog: '/docs/BOREAS_Klima-Santrali-Katalog.pdf'
  },
  {
    id: 'BAF-100',
    brand: 'BOREAS',
    model: 'BAF-100',
    type: 'Hücreli Aspiratör', 
    flow: 10000,
    image: '/images/aspirator/Boreas-BAF.jpg',
    catalog: '/docs/BOREAS_Klima-Santrali-Katalog.pdf'
  },
  {
    id: 'BAF-125',
    brand: 'BOREAS',
    model: 'BAF-125',
    type: 'Hücreli Aspiratör', 
    flow: 12500,
    image: '/images/aspirator/Boreas-BAF.jpg',
    catalog: '/docs/BOREAS_Klima-Santrali-Katalog.pdf'
  },

  // --- Kayıtes Hücreli Aspiratörler ---
  {
    id: 'HASP-280',
    brand: 'KAYITES',
    model: 'HASP-280',
    type: 'Hücreli Aspiratör', 
    flow: 1100,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-280.jpg'
  },
  {
    id: 'HASP-315',
    brand: 'KAYITES',
    model: 'HASP-315',
    type: 'Hücreli Aspiratör', 
    flow: 1600,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-315.jpg'
  },
  {
    id: 'HASP-355',
    brand: 'KAYITES',
    model: 'HASP-355',
    type: 'Hücreli Aspiratör', 
    flow: 2300,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-355.jpg'
  },
  {
    id: 'HASP-500',
    brand: 'KAYITES',
    model: 'HASP-500',
    type: 'Hücreli Aspiratör', 
    flow: 7000,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-315.jpg'
  },
  {
    id: 'HASP-560',
    brand: 'KAYITES',
    model: 'HASP-560',
    type: 'Hücreli Aspiratör', 
    flow: 9800,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-560.jpg'
  },
  {
    id: 'HASP-630',
    brand: 'KAYITES',
    model: 'HASP-630',
    type: 'Hücreli Aspiratör', 
    flow: 14000,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-630.jpg'
  },
  {
    id: 'HASP-710',
    brand: 'KAYITES',
    model: 'HASP-710',
    type: 'Hücreli Aspiratör', 
    flow: 13000,
    image: '/images/aspirator/kayites-hasp.png',
    catalog: '/images/aspirator/kayites-hasp-710.jpg'
  },

  // --- Kayıtes Dikey Atışlı Çatı Tipi Fanlar ---
  {
    id: 'CAXIDIK-400-5-25',
    brand: 'KAYITES',
    model: 'CAXIDIK 400-5-25',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 1200,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-400.jpg'
  },
  {
    id: 'CAXIDIK-450-5-25',
    brand: 'KAYITES',
    model: 'CAXIDIK 450-5-25',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 2200,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-450.jpg'
  },
  {
    id: 'CAXIDIK-500-5-25',
    brand: 'KAYITES',
    model: 'CAXIDIK 500-5-25',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 3950,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-500.jpg'
  },
  {
    id: 'CAXIDIK-560-5-25',
    brand: 'KAYITES',
    model: 'CAXIDIK 560-5-25',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 6100,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-560.jpg'
  },
  {
    id: 'CAXIDIK-630-5-30',
    brand: 'KAYITES',
    model: 'CAXIDIK 630-5-30',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 11000,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-630.jpg'
  },
  {
    id: 'CAXIDIK-710-5-30',
    brand: 'KAYITES',
    model: 'CAXIDIK 710-5-30',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 17000,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-710.jpg'
  },
  {
    id: 'CAXIDIK-800-5-30',
    brand: 'KAYITES',
    model: 'CAXIDIK 800-5-30',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 22250,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-800.jpg'
  },
  {
    id: 'CAXIDIK-800-5-35',
    brand: 'KAYITES',
    model: 'CAXIDIK 800-5-35',
    type: 'Çatı Tipi Fan - Dikey Atışlı',
    flow: 26940,
    image: '/images/aspirator/kayites-caxidik.png',
    catalog: '/images/aspirator/kayites-caxidik-800-5-35.jpg'
  },
  // --- Kayıtes Yatay Atışlı Çatı Tipi Fanlar (CRAD serisi) ---
  {
    id: 'CRAD-190',
    brand: 'KAYITES',
    model: 'CRAD 190',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 520,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-190.jpg'
  },
  {
    id: 'CRAD-225',
    brand: 'KAYITES',
    model: 'CRAD 225',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 950,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-225.jpg'
  },
  {
    id: 'CRAD-250',
    brand: 'KAYITES',
    model: 'CRAD 250',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 1150,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-250.jpg'
  },
  {
    id: 'CRAD-355',
    brand: 'KAYITES',
    model: 'CRAD 355',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 2350,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-355.jpg'
  },
  {
    id: 'CRAD-400',
    brand: 'KAYITES',
    model: 'CRAD 400',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 3400,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-400.jpg'
  },
  {
    id: 'CRAD-450',
    brand: 'KAYITES',
    model: 'CRAD 450',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 4900,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-450.jpg'
  },
  {
    id: 'CRAD-500',
    brand: 'KAYITES',
    model: 'CRAD 500',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 7000,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-500.jpg'
  },
  {
    id: 'CRAD-560',
    brand: 'KAYITES',
    model: 'CRAD 560',
    type: 'Çatı Tipi Fan - Yatay Atışlı',
    flow: 9300,
    image: '/images/aspirator/kayites-crad.png',
    catalog: '/images/aspirator/kayites-crad-560.jpg'
  },
 // --- Kayıtes Kanal Tipi Fanlar (Dikdörtgen) ---
{
  id: 'REC-30-15',
  brand: 'KAYITES',
  model: 'REC 30-15',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 520,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-30-15.jpg',
},
{
  id: 'REC-40-20A',
  brand: 'KAYITES',
  model: 'REC 40-20 A',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 950,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-40-20a.jpg',
},
{
  id: 'REC-40-20B',
  brand: 'KAYITES',
  model: 'REC 40-20 B',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 1150,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-40-20b.jpg',
},
{
  id: 'REC-50-25',
  brand: 'KAYITES',
  model: 'REC 50-25',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 1600,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-50-25.jpg',
},
{
  id: 'REC-60-30',
  brand: 'KAYITES',
  model: 'REC 60-30',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 2350,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-60-30.jpg',
},
{
  id: 'REC-60-35',
  brand: 'KAYITES',
  model: 'REC 60-35',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 3400,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-60-35.jpg',
},
{
  id: 'REC-70-40',
  brand: 'KAYITES',
  model: 'REC 70-40',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 4900,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-70-40.jpg',
},
{
  id: 'REC-80-50',
  brand: 'KAYITES',
  model: 'REC 80-50',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 7000,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-80-50.jpg',
},
{
  id: 'REC-100-50',
  brand: 'KAYITES',
  model: 'REC 100-50',
  type: 'Kanal Tipi Fan - Dikdörtgen',
  flow: 9300,
  image: '/images/aspirator/kayites-rec.png',
  catalog: '/images/aspirator/kayites-rec-100-50.jpg',
},

// --- Kayıtes Kanal Tipi Fanlar (Yuvarlak Kanal) ---
{
  id: 'RAD-100',
  brand: 'KAYITES',
  model: 'RAD 100',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 290,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-100.jpg',
},
{
  id: 'RAD-125',
  brand: 'KAYITES',
  model: 'RAD 125',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 410,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-125.jpg',
},
{
  id: 'RAD-150',
  brand: 'KAYITES',
  model: 'RAD 150',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 700,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-150.jpg',
},
{
  id: 'RAD-160',
  brand: 'KAYITES',
  model: 'RAD 160',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 710,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-160.jpg',
},
{
  id: 'RAD-200',
  brand: 'KAYITES',
  model: 'RAD 200',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 1000,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-200.jpg',
},
{
  id: 'RAD-250',
  brand: 'KAYITES',
  model: 'RAD 250',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 1120,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-250.jpg',
},
{
  id: 'RAD-315',
  brand: 'KAYITES',
  model: 'RAD 315',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 1750,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-315.jpg',
},
{
  id: 'RAD-355',
  brand: 'KAYITES',
  model: 'RAD 355',
  type: 'Kanal Tipi Fan - Yuvarlak Kanal',
  flow: 2200,
  image: '/images/aspirator/kayites-rad.png',
  catalog: '/images/aspirator/kayites-rad-355.jpg',
},
// --- Kayıtes Duman Tahliye Fanları (CTAXI serisi) ---
{
  id: 'CTAXI-450-5-25',
  brand: 'KAYITES',
  model: 'CTAXI 450-5-25',
  type: 'Duman Tahliye Fanı',
  flow: 2200,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-450-5-25.jpg',
},
{
  id: 'CTAXI-500-5-25',
  brand: 'KAYITES',
  model: 'CTAXI 500-5-25',
  type: 'Duman Tahliye Fanı',
  flow: 3950,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-500-5-25.jpg',
},
{
  id: 'CTAXI-560-5-25',
  brand: 'KAYITES',
  model: 'CTAXI 560-5-25',
  type: 'Duman Tahliye Fanı',
  flow: 6100,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-560-5-25.jpg',
},
{
  id: 'CTAXI-630-5-30',
  brand: 'KAYITES',
  model: 'CTAXI 630-5-30',
  type: 'Duman Tahliye Fanı',
  flow: 11000,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-630-5-30.jpg',
},
{
  id: 'CTAXI-710-5-30',
  brand: 'KAYITES',
  model: 'CTAXI 710-5-30',
  type: 'Duman Tahliye Fanı',
  flow: 17000,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-710-5-30.jpg',
},
{
  id: 'CTAXI-800-5-30',
  brand: 'KAYITES',
  model: 'CTAXI 800-5-30',
  type: 'Duman Tahliye Fanı',
  flow: 22250,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-800-5-30.jpg',
},
{
  id: 'CTAXI-800-5-35',
  brand: 'KAYITES',
  model: 'CTAXI 800-5-35',
  type: 'Duman Tahliye Fanı',
  flow: 26940,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-800-5-35.jpg',
},
{
  id: 'CTAXI-900-5-35',
  brand: 'KAYITES',
  model: 'CTAXI 900-5-35',
  type: 'Duman Tahliye Fanı',
  flow: 34150,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-900-5-35.jpg',
},
{
  id: 'CTAXI-900-5-40',
  brand: 'KAYITES',
  model: 'CTAXI 900-5-40',
  type: 'Duman Tahliye Fanı',
  flow: 40000,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-900-5-40.jpg',
},
{
  id: 'CTAXI-1000-5-40',
  brand: 'KAYITES',
  model: 'CTAXI 1000-5-40',
  type: 'Duman Tahliye Fanı',
  flow: 49570,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-1000-5-40.jpg',
},
{
  id: 'CTAXI-900-8-40',
  brand: 'KAYITES',
  model: 'CTAXI 900-8-40',
  type: 'Duman Tahliye Fanı',
  flow: 43200,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-900-8-40.jpg',
},
{
  id: 'CTAXI-1000-8-40',
  brand: 'KAYITES',
  model: 'CTAXI 1000-8-40',
  type: 'Duman Tahliye Fanı',
  flow: 58850,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-1000-8-40.jpg',
},
{
  id: 'CTAXI-1000-8-45',
  brand: 'KAYITES',
  model: 'CTAXI 1000-8-45',
  type: 'Duman Tahliye Fanı',
  flow: 66070,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-1000-8-45.jpg',
},
{
  id: 'CTAXI-1120-8-40',
  brand: 'KAYITES',
  model: 'CTAXI 1120-8-40',
  type: 'Duman Tahliye Fanı',
  flow: 84620,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-1120-8-40.jpg',
},
{
  id: 'CTAXI-1120-8-45',
  brand: 'KAYITES',
  model: 'CTAXI 1120-8-45',
  type: 'Duman Tahliye Fanı',
  flow: 92270,
  image: '/images/aspirator/kayites-ctaxi.png',
  catalog: '/images/aspirator/kayites-ctaxi-1120-8-45.jpg',
},
// --- Kayıtes TAXI Serisi Aksiyel Fanlar ---
{
  id: 'TAXI-450-5-25',
  brand: 'KAYITES',
  model: 'TAXI 450-5-25',
  type: 'Aksiyel Fan',
  flow: 4180,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-450-5-25.jpg',
},
{
  id: 'TAXI-500-5-25',
  brand: 'KAYITES',
  model: 'TAXI 500-5-25',
  type: 'Aksiyel Fan',
  flow: 5845,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-500-5-25.jpg',
},
{
  id: 'TAXI-560-5-25',
  brand: 'KAYITES',
  model: 'TAXI 560-5-25',
  type: 'Aksiyel Fan',
  flow: 8150,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-560-5-25.jpg',
},
{
  id: 'TAXI-630-5-30',
  brand: 'KAYITES',
  model: 'TAXI 630-5-30',
  type: 'Aksiyel Fan',
  flow: 13480,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-630-5-30.jpg',
},
{
  id: 'TAXI-710-5-30',
  brand: 'KAYITES',
  model: 'TAXI 710-5-30',
  type: 'Aksiyel Fan',
  flow: 19210,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-710-5-30.jpg',
},
{
  id: 'TAXI-800-5-30',
  brand: 'KAYITES',
  model: 'TAXI 800-5-30',
  type: 'Aksiyel Fan',
  flow: 25560,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-800-5-30.jpg',
},
{
  id: 'TAXI-800-5-35',
  brand: 'KAYITES',
  model: 'TAXI 800-5-35',
  type: 'Aksiyel Fan',
  flow: 30940,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-800-5-35.jpg',
},
{
  id: 'TAXI-900-5-35',
  brand: 'KAYITES',
  model: 'TAXI 900-5-35',
  type: 'Aksiyel Fan',
  flow: 39250,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-900-5-35.jpg',
},
{
  id: 'TAXI-900-5-40',
  brand: 'KAYITES',
  model: 'TAXI 900-5-40',
  type: 'Aksiyel Fan',
  flow: 44635,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-900-5-40.jpg',
},
{
  id: 'TAXI-1000-5-40',
  brand: 'KAYITES',
  model: 'TAXI 1000-5-40',
  type: 'Aksiyel Fan',
  flow: 54570,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-1000-5-40.jpg',
},
{
  id: 'TAXI-900-8-40',
  brand: 'KAYITES',
  model: 'TAXI 900-8-40',
  type: 'Aksiyel Fan',
  flow: 46200,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-900-8-40.jpg',
},
{
  id: 'TAXI-1000-8-40',
  brand: 'KAYITES',
  model: 'TAXI 1000-8-40',
  type: 'Aksiyel Fan',
  flow: 62250,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-1000-8-40.jpg',
},
{
  id: 'TAXI-1000-8-45',
  brand: 'KAYITES',
  model: 'TAXI 1000-8-45',
  type: 'Aksiyel Fan',
  flow: 69070,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-1000-8-45.jpg',
},
{
  id: 'TAXI-1120-8-40',
  brand: 'KAYITES',
  model: 'TAXI 1120-8-40',
  type: 'Aksiyel Fan',
  flow: 86620,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-1120-8-40.jpg',
},
{
  id: 'TAXI-1120-8-45',
  brand: 'KAYITES',
  model: 'TAXI 1120-8-45',
  type: 'Aksiyel Fan',
  flow: 95270,
  image: '/images/aspirator/kayites-taxi.png',
  catalog: '/images/aspirator/kayites-taxi-1120-8-45.jpg',
},


];

export default FAN_PRODUCTS;
